import { MultipleChoiceExamEndIllustration } from '../../../../../assets/illustrations';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

/** Closing screen, once every answer has been recorded and uploaded. */
function InterviewEnd() {
    const navigate = useNavigate();

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamEndIllustration />
            <span className={styles.title}>Well done!</span>
            <span className={styles.text}>You finished the interview.</span>
            <Button
                type='Primary'
                text='Go to dashboard'
                className={styles.navigate}
                onClick={() => navigate('/workspace')}
            />
        </MotionWrapper>
    )
};

export default InterviewEnd;
